function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable react/no-danger */
import React, { useEffect, useRef } from 'react';
import cn from "../../../utils/cn";
import PropTypes from 'prop-types';
import EmailAddress from "../../Display/Contact/EmailAddress/EmailAddress";
import HoursOfOperation from "../../Display/HoursOfOperation/HoursOfOperation";
import PhoneNumbers from "../../Display/Contact/PhoneNumbers/PhoneNumbers";
import Locations from "../../Display/Location/Locations/Locations";
import addresses from "../../utils/Addresses";
import Icon from "../../Display/Icon/Icon";
import MoreOrLessButton from "../../Display/MoreOrLessButton/MoreOrLessButton";
import Card from "../../Display/Card/Card";
import Services from "./Services/Services";
import StaticMap from "../../Display/StaticMap/StaticMap";
import Eligibility from "../../Display/Program/Eligibility/Eligibility";
import ProgramCard from "./ProgramCard/ProgramCard";
import MoreResultsButton from "./MoreResultsButton/MoreResultsButton";
import CardSkeleton from "./CardSkeleton/CardSkeleton";
import generateUUID from "../../../utils/generateUUID";
import { SERVICE_AREA_TYPES, SCROLL_TO } from "./utils/constants";
import { flatServicesPropType, hoursPropType } from "./utils/propTypes";
import "./ProgramDetail.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DISPLAY_NAME = 'program-detail';
function ProgramDetail(_ref) {
  let {
    className,
    id,
    name,
    description,
    eligibility_text,
    population_restrictions,
    accessibility_options,
    delivery_options,
    payment_options,
    population_specializations,
    languages,
    transportation_options,
    city_requirements,
    county_requirements,
    state_requirements,
    age_specializations,
    gender_requirements,
    age_requirements,
    postal_code_requirements,
    latitude,
    longitude,
    provider_name,
    hasOrgInfo,
    providerPrograms: {
      programs,
      moreCount,
      isLoading,
      hasNextPage,
      fetchNextPage,
      isFetchingNextPage
    },
    provider_description,
    provider_email_addresses,
    provider_phone_numbers,
    provider_website_url,
    provider_locations,
    provider_hours,
    servingArea,
    address,
    zoom,
    hasMap,
    provider_licensed,
    services,
    hasRequirements,
    hasAccessibility,
    hasOtherEligibility,
    hasEligibility,
    hasContactInfo,
    phone_numbers,
    email_addresses,
    website_url,
    locations,
    hours,
    uup459SupersetPhase2,
    cerb1367ResourceListDetailEnhancements,
    googleApiKey,
    fromLatitude,
    fromLongitude,
    renderHeader,
    scrollTo,
    isEmr,
    appRoles
  } = _ref;
  const serviceTypesRef = useRef(null);
  const descriptionRef = useRef(null);
  useEffect(() => {
    const scrollToElement = () => {
      if (cerb1367ResourceListDetailEnhancements) {
        if (scrollTo === SCROLL_TO.SERVICE_TYPES_SCROLL_POSITION && serviceTypesRef.current) {
          serviceTypesRef.current.scrollIntoView({
            behavior: 'smooth'
          });
        } else if (scrollTo === SCROLL_TO.DESCRIPTION_SCROLL_POSITION && descriptionRef.current) {
          descriptionRef.current.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    };
    // Ensure that elements are rendered before trying to scroll
    const timeoutId = setTimeout(scrollToElement, 100); // Delay to ensure rendering

    return () => clearTimeout(timeoutId);
  }, [cerb1367ResourceListDetailEnhancements, scrollTo, id]);

  // ensure provider_locations stores coords in a format that <Location> likes
  const providerLocationsForDisplay = provider_locations === null || provider_locations === void 0 ? void 0 : provider_locations.map(pl => {
    var _pl$coordinates, _pl$coordinates2;
    return _objectSpread(_objectSpread({}, pl), {}, {
      latitude: (_pl$coordinates = pl.coordinates) === null || _pl$coordinates === void 0 ? void 0 : _pl$coordinates.lat,
      longitude: (_pl$coordinates2 = pl.coordinates) === null || _pl$coordinates2 === void 0 ? void 0 : _pl$coordinates2.lon
    });
  });
  return /*#__PURE__*/_jsxs("aside", {
    className: cn(className, 'relative bg-lighter-grey'),
    children: [renderHeader ? renderHeader() : /*#__PURE__*/_jsx("header", {
      className: cn(DISPLAY_NAME, 'flex justify-between bg-white border-b border-solid border-med-pale-blue p-4'),
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("h1", {
          className: "pb-2 text-dark-blue",
          children: name
        }), /*#__PURE__*/_jsxs("p", {
          children: ['provided by ', /*#__PURE__*/_jsx("span", {
            className: "text-purple",
            children: provider_name
          })]
        })]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: cn("".concat(DISPLAY_NAME, "__content"), 'p-4'),
      children: [/*#__PURE__*/_jsxs(Card, {
        className: cn("".concat(DISPLAY_NAME, "__map-card"), 'border border-solid rounded border-med-pale-blue bg-white', 'mb-4', 'p-3'),
        children: [hasMap && googleApiKey && /*#__PURE__*/_jsx(StaticMap, {
          providerLicensed: provider_licensed,
          latLng: {
            latitude,
            longitude
          },
          zoom: zoom,
          apiKey: googleApiKey
        }), /*#__PURE__*/_jsx("div", {
          className: hasMap ? 'my-3' : '',
          children: address && /*#__PURE__*/_jsxs("p", {
            className: "flex items-center text-brand-blue",
            children: [/*#__PURE__*/_jsx(Icon, {
              icon: "MapPin"
            }), /*#__PURE__*/_jsx("span", {
              className: "ml-2",
              children: address + (servingArea && latitude && longitude ? " (".concat(addresses.getDistanceInMiles([latitude, longitude], [fromLatitude, fromLongitude]), ")") : '')
            })]
          })
        }), /*#__PURE__*/_jsx("div", {
          children: servingArea && /*#__PURE__*/_jsxs("p", {
            className: "flex items-center text-brand-blue",
            children: [/*#__PURE__*/_jsx(Icon, {
              icon: "Radar"
            }), servingArea === SERVICE_AREA_TYPES.NATIONAL ? /*#__PURE__*/_jsx("span", {
              className: "ml-2",
              children: "Serves the United States"
            }) : /*#__PURE__*/_jsx("span", {
              className: "ml-2",
              children: "Serves the state of ".concat(servingArea)
            })]
          })
        })]
      }), /*#__PURE__*/_jsx(Card, {
        title: "Program Description",
        className: "".concat(DISPLAY_NAME, "__description-text border border-solid rounded border-med-pale-blue bg-white mb-6"),
        ref: descriptionRef,
        children: /*#__PURE__*/_jsx("p", {
          dangerouslySetInnerHTML: {
            __html: description
          },
          className: "p-3"
        })
      }), /*#__PURE__*/_jsx(Eligibility, {
        className: className,
        eligibilityText: eligibility_text,
        populationRestrictions: population_restrictions,
        populationSpecializations: population_specializations,
        paymentOptions: payment_options,
        accessibilityOptions: accessibility_options,
        deliveryOptions: delivery_options,
        languages: languages,
        transportationOptions: transportation_options,
        cityRequirements: city_requirements,
        countyRequirements: county_requirements,
        ageSpecializations: age_specializations,
        genderRequirements: gender_requirements,
        ageRequirements: age_requirements,
        postalCodeRequirements: postal_code_requirements,
        hasRequirements: hasRequirements,
        hasAccessibility: hasAccessibility,
        hasOtherEligibility: hasOtherEligibility,
        hasEligibility: hasEligibility,
        stateRequirements: state_requirements
      }), services.length > 0 && /*#__PURE__*/_jsx(Card, {
        title: "Service Types Offered",
        className: "".concat(DISPLAY_NAME, "__org_service_types border border-solid rounded border-med-pale-blue bg-white mb-6"),
        ref: serviceTypesRef,
        children: /*#__PURE__*/_jsx(Services, {
          services: services
        })
      }), hasContactInfo && /*#__PURE__*/_jsxs(Card, {
        title: "Program Contact Information",
        className: "".concat(DISPLAY_NAME, "__org_contact_info border border-solid rounded border-med-pale-blue bg-white mb-6"),
        children: [phone_numbers && /*#__PURE__*/_jsx("div", {
          className: "".concat(DISPLAY_NAME, "__org_contact_info__phone_numbers items-center m-3 pl-1 text-action-blue"),
          children: /*#__PURE__*/_jsx(PhoneNumbers, {
            phone_numbers: phone_numbers
          })
        }), email_addresses && email_addresses.map(email => /*#__PURE__*/_jsxs("p", {
          className: "".concat(DISPLAY_NAME, "__org_contact_info__email_addresses items-center m-3 pl-1"),
          children: [/*#__PURE__*/_jsx(Icon, {
            icon: "Email"
          }), /*#__PURE__*/_jsx(EmailAddress, {
            emailAddress: email,
            className: "ml-1"
          })]
        }, email)), website_url && /*#__PURE__*/_jsx("p", {
          className: "".concat(DISPLAY_NAME, "__org_contact_info__website_url items-center m-3 pl-1"),
          children: /*#__PURE__*/_jsxs("a", {
            href: website_url,
            children: [/*#__PURE__*/_jsx(Icon, {
              icon: "Globe"
            }), /*#__PURE__*/_jsx("span", {
              className: "".concat(DISPLAY_NAME, "__org_contact_info__website_url__text ml-1 text-action-blue"),
              children: "Visit Website"
            })]
          })
        }), hours && /*#__PURE__*/_jsx("div", {
          className: "".concat(DISPLAY_NAME, "__org_contact_info__hours"),
          children: /*#__PURE__*/_jsx(HoursOfOperation, {
            hours: hours,
            showAll: true,
            showToggle: true,
            showHoursIcon: true,
            hoursLabel: "Hours",
            abbreviateDays: false,
            closedText: "Closed",
            shouldStartWeekToday: true,
            className: "m-3 pl-1"
          })
        }), locations && /*#__PURE__*/_jsx("div", {
          className: "".concat(DISPLAY_NAME, "__org_contact_info__locations m-3 pl-1"),
          children: locations.length > 1 ?
          /*#__PURE__*/
          // showHours to be disabled will need client-util changes
          _jsx(MoreOrLessButton, {
            moreText: "See more locations",
            lessText: "See less locations",
            children: /*#__PURE__*/_jsx(Locations, {
              locations: locations,
              originLatLng: [fromLatitude, fromLongitude],
              showMore: true
            })
          }) : /*#__PURE__*/_jsx(Locations, {
            locations: locations,
            originLatLng: [fromLatitude, fromLongitude],
            showMore: true
          })
        })]
      }), hasOrgInfo && /*#__PURE__*/_jsxs(Card, {
        title: "Organization Information",
        className: "".concat(DISPLAY_NAME, "__org_info_content border border-solid rounded border-med-pale-blue bg-white mb-6"),
        children: [provider_description && /*#__PURE__*/_jsxs("p", {
          className: cn("".concat(DISPLAY_NAME, "__field-name"), 'm-3 py-2 pl-1 text-dark-blue flex'),
          children: [/*#__PURE__*/_jsx("span", {
            className: "font-medium-font mr-2 shrink-0",
            style: {
              flexShrink: 0
            },
            children: "Description:"
          }), /*#__PURE__*/_jsx("span", {
            dangerouslySetInnerHTML: {
              __html: provider_description
            },
            className: cn("".concat(DISPLAY_NAME, "__field-value"), 'capitalize font-normal text-brand-blue')
          })]
        }), provider_phone_numbers && /*#__PURE__*/_jsx("div", {
          className: "".concat(DISPLAY_NAME, "__org_info_content__phone_numbers items-center m-3 pl-1 text-action-blue"),
          children: /*#__PURE__*/_jsx(PhoneNumbers, {
            phone_numbers: provider_phone_numbers
          })
        }), provider_email_addresses && provider_email_addresses.map(email => /*#__PURE__*/_jsxs("p", {
          className: "".concat(DISPLAY_NAME, "__org_info_content__email_addresses items-center m-3 pl-1"),
          children: [/*#__PURE__*/_jsx(Icon, {
            icon: "Email"
          }), /*#__PURE__*/_jsx(EmailAddress, {
            emailAddress: email,
            className: "ml-1"
          })]
        }, email)), (provider_website_url === null || provider_website_url === void 0 ? void 0 : provider_website_url.length) && /*#__PURE__*/_jsx("p", {
          className: "".concat(DISPLAY_NAME, "__org_info_content__website_url items-center m-3 pl-1"),
          children: /*#__PURE__*/_jsxs("a", {
            href: provider_website_url,
            children: [/*#__PURE__*/_jsx(Icon, {
              icon: "Globe",
              className: "mr-1"
            }), /*#__PURE__*/_jsx("span", {
              className: "".concat(DISPLAY_NAME, "__org_info_content__website_url__text text-action-blue"),
              children: "Visit Website"
            })]
          })
        }), provider_hours && /*#__PURE__*/_jsx("div", {
          className: "".concat(DISPLAY_NAME, "__org_info_content__hours"),
          children: /*#__PURE__*/_jsx(HoursOfOperation, {
            hours: provider_hours,
            showAll: true,
            showToggle: true,
            showHoursIcon: true,
            hoursLabel: "Hours",
            abbreviateDays: false,
            closedText: "Closed",
            shouldStartWeekToday: true,
            className: "m-3 pl-1"
          })
        }), provider_locations && /*#__PURE__*/_jsx("div", {
          className: "".concat(DISPLAY_NAME, "__org_info_content__locations m-3 pl-1"),
          children: provider_locations.length > 1 ? /*#__PURE__*/_jsx(MoreOrLessButton, {
            moreText: "See more locations",
            lessText: "See less locations",
            children: /*#__PURE__*/_jsx(Locations, {
              locations: providerLocationsForDisplay,
              originLatLng: [fromLatitude, fromLongitude],
              showMore: true
            })
          }) : /*#__PURE__*/_jsx(Locations, {
            locations: providerLocationsForDisplay,
            originLatLng: [fromLatitude, fromLongitude],
            showMore: true
          })
        })]
      }), !isLoading && programs.length > 1 && /*#__PURE__*/_jsxs(Card, {
        title: "Other Programs at this Organization",
        className: "".concat(DISPLAY_NAME, "__other-programs border border-solid rounded border-med-pale-blue bg-white"),
        children: [programs.filter(o => o.id !== id).map(p => /*#__PURE__*/_jsx(ProgramCard, {
          id: "".concat(p.id, "-other-program"),
          className: "border-l-0 border-r-0 border-t-0 border-b-solid border-b-med-pale-blue",
          title: p.name,
          description: p.description,
          provider: p.provider_name,
          distance: p.distance,
          isPrioritized: p.is_prioritized,
          serviceNames: p.service_names,
          services: p.services,
          status: p.status,
          deliveryLocation: p.delivery_options,
          isServingArea: p.is_serving_area,
          feeSchedule: p.fee_schedule_program,
          phone: p.phone_primary,
          hours: p.provider_hours,
          onSelectProgram: () => {},
          onCardClick: () => {},
          isProgramDetail: true,
          isEmr: isEmr,
          appRoles: appRoles,
          headingLevel: "h3",
          hasHeaderDivider: false,
          providerLicensed: provider_licensed,
          receivingReferrals: p.receiving_referrals,
          uniqueKey: "".concat(p.id, "-other-program"),
          uup459SupersetPhase2: uup459SupersetPhase2,
          cerb1367ResourceListDetailEnhancements: cerb1367ResourceListDetailEnhancements
        }, "".concat(p.id, "-other-program"))), isFetchingNextPage && Array(moreCount).fill(0).map(() => /*#__PURE__*/_jsx(CardSkeleton, {}, generateUUID())), hasNextPage && !isFetchingNextPage && /*#__PURE__*/_jsx(MoreResultsButton, {
          onClick: fetchNextPage,
          moreCount: moreCount
        })]
      })]
    })]
  });
}
ProgramDetail.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  eligibility_text: PropTypes.string,
  providerPrograms: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    programs: PropTypes.arrayOf(PropTypes.object),
    moreCount: PropTypes.number,
    isLoading: PropTypes.bool,
    hasNextPage: PropTypes.bool,
    fetchNextPage: PropTypes.func,
    isFetchingNextPage: PropTypes.bool
  }),
  provider_name: PropTypes.string,
  hasOrgInfo: PropTypes.bool,
  provider_description: PropTypes.string,
  provider_email_addresses: PropTypes.arrayOf(PropTypes.string),
  provider_phone_numbers: PropTypes.arrayOf(PropTypes.shape({
    is_primary: PropTypes.bool,
    phone_type: PropTypes.string,
    country_code: PropTypes.string,
    phone_number: PropTypes.string,
    extension: PropTypes.string
  })),
  provider_website_url: PropTypes.string,
  provider_hours: hoursPropType,
  provider_locations: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    line_1: PropTypes.string,
    city: PropTypes.string,
    county: PropTypes.string,
    state: PropTypes.string,
    postal_code: PropTypes.string,
    country: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number
  })),
  population_restrictions: PropTypes.string,
  population_specializations: PropTypes.string,
  accessibility_options: PropTypes.string,
  delivery_options: PropTypes.string,
  payment_options: PropTypes.string,
  residency: PropTypes.shape({
    state_requirements: PropTypes.string.isRequired,
    city_requirements: PropTypes.string.isRequired,
    county_requirements: PropTypes.string.isRequired,
    postal_code_requirements: PropTypes.string.isRequired
  }),
  languages: PropTypes.string,
  transportation_options: PropTypes.string,
  city_requirements: PropTypes.string,
  county_requirements: PropTypes.string,
  state_requirements: PropTypes.string,
  age_specializations: PropTypes.string,
  gender_requirements: PropTypes.string,
  age_requirements: PropTypes.string,
  postal_code_requirements: PropTypes.string,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  servingArea: PropTypes.string,
  address: PropTypes.string,
  zoom: PropTypes.string,
  hasMap: PropTypes.bool,
  provider_licensed: PropTypes.bool,
  services: flatServicesPropType,
  hasRequirements: PropTypes.bool,
  hasAccessibility: PropTypes.bool,
  hasOtherEligibility: PropTypes.bool,
  hasEligibility: PropTypes.bool,
  hasContactInfo: PropTypes.bool,
  phone_numbers: PropTypes.arrayOf(PropTypes.shape({
    is_primary: PropTypes.bool,
    phone_type: PropTypes.string,
    country_code: PropTypes.string,
    phone_number: PropTypes.string,
    extension: PropTypes.string
  })),
  email_addresses: PropTypes.arrayOf(PropTypes.string),
  website_url: PropTypes.string,
  locations: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    line_1: PropTypes.string,
    city: PropTypes.string,
    county: PropTypes.string,
    state: PropTypes.string,
    postal_code: PropTypes.string,
    country: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number
  })),
  hours: hoursPropType,
  otherPrograms: PropTypes.arrayOf(
  // eslint-disable-line react/no-unused-prop-types
  PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    description: PropTypes.string,
    distance: PropTypes.string,
    is_prioritized: PropTypes.bool,
    receiving_referrals: PropTypes.bool,
    phone_numbers: PropTypes.arrayOf(PropTypes.shape({
      is_primary: PropTypes.bool,
      phone_type: PropTypes.string,
      country_code: PropTypes.string,
      phone_number: PropTypes.string,
      extension: PropTypes.string
    })),
    phone_primary: PropTypes.string,
    services: flatServicesPropType,
    service_names: PropTypes.arrayOf(PropTypes.string),
    delivery_options: PropTypes.string,
    service_areas: PropTypes.arrayOf(PropTypes.shape({
      service_area_type: PropTypes.string,
      state_abbreviation: PropTypes.string
    })),
    is_serving_area: PropTypes.bool,
    provider_name: PropTypes.string,
    provider_hours: hoursPropType
  })),
  uup459SupersetPhase2: PropTypes.bool,
  cerb1367ResourceListDetailEnhancements: PropTypes.bool,
  googleApiKey: PropTypes.string,
  fromLatitude: PropTypes.number,
  fromLongitude: PropTypes.number,
  renderHeader: PropTypes.func,
  scrollTo: PropTypes.string,
  isEmr: PropTypes.bool,
  appRoles: PropTypes.array
};
ProgramDetail.defaultProps = {
  providerPrograms: {
    programs: []
  },
  className: '',
  id: '',
  name: '',
  description: '',
  eligibility_text: '',
  provider_name: '',
  hasOrgInfo: false,
  provider_description: '',
  provider_email_addresses: [],
  provider_phone_numbers: [],
  provider_website_url: '',
  provider_hours: {},
  provider_locations: [],
  population_restrictions: '',
  population_specializations: '',
  accessibility_options: '',
  delivery_options: '',
  payment_options: '',
  languages: '',
  transportation_options: '',
  city_requirements: '',
  county_requirements: '',
  state_requirements: '',
  age_specializations: '',
  gender_requirements: '',
  age_requirements: '',
  postal_code_requirements: '',
  latitude: 0,
  longitude: 0,
  servingArea: '',
  address: '',
  zoom: '6',
  hasMap: false,
  provider_licensed: false,
  services: [],
  residency: {
    state_requirements: '',
    city_requirements: '',
    county_requirements: '',
    postal_code_requirements: ''
  },
  hasEligibility: false,
  hasContactInfo: false,
  hasRequirements: false,
  hasAccessibility: false,
  hasOtherEligibility: false,
  phone_numbers: [],
  email_addresses: [],
  website_url: '',
  locations: [],
  hours: {},
  otherPrograms: [],
  uup459SupersetPhase2: false,
  cerb1367ResourceListDetailEnhancements: false,
  googleApiKey: '',
  fromLatitude: 0,
  fromLongitude: 0,
  renderHeader: undefined,
  scrollTo: null,
  isEmr: false,
  appRoles: []
};
export default /*#__PURE__*/React.memo(ProgramDetail);
//# sourceMappingURL=ProgramDetail.js.map